import React from "react";
const AboutUs = ({ classicHeader, darkTheme, t, handlePrint }) => {
    function calculateAge(birthday) { // birthday is a date
      var ageDifMs = Date.now() - birthday;
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    };
  return (
    <section
      id="about"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {t.about.title}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {t.about.title}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              <span className="text-primary">{t.about.heading}</span>
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              {t.about.intro1}
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
              {t.about.intro2}
            </p>
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">{t.about.name}</span>Daniel B. Oliveira
                </li>
                <li>
                  <span className="fw-600 me-2">{t.about.email}</span>
                  <a href="mailto:daniel@opencae.com.br">daniel@opencae.com.br</a>
                </li>
                <li>
                  <span className="fw-600 me-2">{t.about.age}</span>
                  {
                    calculateAge(new Date('1987-09-17T13:29:15.524486Z'))
                  }
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">{t.about.from}</span>Belo Horizonte City, Minas Gerais State, Brazil
                </li>
              </ul>
              <button
                type="button"
                onClick={handlePrint}
                className="btn btn-primary rounded-pill"
              >
                {t.about.download}
              </button>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>
                  {
                      calculateAge(new Date('2016-01-20T13:29:15.524486Z'))
                  }
                  </span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  {t.about.experience}
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>50</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  {t.about.projects}
                </p>
              </div>
            </div>
            {/*<div className="col-6 col-md-3">
                          <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>38</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>*/}
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
